import { FormProvider } from 'react-hook-form';
import { useCreateUserForm } from './hooks';
import { CreateUserFormPresentation } from './presentations';

/**
 * 利用者新規作成フォーム Container コンポーネント
 * 利用者の新規作成を管理し、作成フォームを表示する
 */
export const CreateUserForm: React.FC = () => {
  const {
    state: { methods, branchOptions, isMutating },
    actions: { handleSubmit, handleCancel },
  } = useCreateUserForm();

  return (
    <FormProvider {...methods}>
      <CreateUserFormPresentation
        branchOptions={branchOptions}
        isMutating={isMutating}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </FormProvider>
  );
};
